// Module
var code = "<img alt=\"\" flex=\"none\" ng-if=\"('profile.logo'|cdSettings).length > 0\" ng-src=\"{{ 'profile.logo' | cdSettings }}\"/> <img alt=\"\" flex=\"none\" ng-init=\"logo = ('profile.logo'|cdSettings)\" ng-if=\"('profile.logo'|cdSettings).name\" ngf-thumbnail=\"logo\"/> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-logo.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;